import { useEffect, useState } from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import PremiumSoftChews from './components/PremiumSoftChews';
import WellnessStorySection from './components/WellnessStorySection';
import Testimonials from './components/Testimonials';
import DiscoverMore from './components/DiscoverMore';
import InstagramSlider from './components/InstagramSlider';
import Footer from './components/Footer';
import NewsletterBanner from './components/NewsletterBanner';
import SitePage, { getPageDefinition } from './pages/SitePage';
import AboutPage from './pages/AboutPage';
import PageMetadata from './components/PageMetadata';
import ShopPage, { CartPage, isShopPath } from './pages/ShopPage';
import './App.css';

function App() {
  const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem('trillium-paws-cart')) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem('trillium-paws-cart', JSON.stringify(cart)); }, [cart]);

  const addToCart = product => {
    const existing = cart.find(item => item.id === product.id);
    const nextCart = existing
      ? cart.map(item => item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item)
      : [...cart, { id: product.id, name: product.name, price: product.price, image: product.image, quantity: 1 }];
    setCart(nextCart);
    localStorage.setItem('trillium-paws-cart', JSON.stringify(nextCart));
  };
  const changeQuantity = (id, quantity) => setCart(current => quantity < 1 ? current.filter(item => item.id !== id) : current.map(item => item.id === id ? { ...item, quantity } : item));
  const removeFromCart = id => setCart(current => current.filter(item => item.id !== id));
  const cartCount = cart.reduce((total, item) => total + item.quantity, 0);
  const page = getPageDefinition(pathname);

  return <>
    <PageMetadata pathname={pathname} page={page} />
    <Header cartCount={cartCount} />
    {pathname === '/cart' ? <CartPage cart={cart} onChangeQuantity={changeQuantity} onRemove={removeFromCart} onClear={() => setCart([])} />
      : isShopPath(pathname) ? <ShopPage pathname={pathname} onAdd={addToCart} />
      : pathname === '/about' ? <AboutPage />
      : page ? <SitePage page={page} />
      : <main id="main-content"><Hero /><TrustBar /><PremiumSoftChews onAdd={addToCart} /><WellnessStorySection /><DiscoverMore /><Testimonials /><InstagramSlider /><NewsletterBanner /></main>}
    <Footer />
  </>;
}

export default App;
